import type { Lang } from '../i18n/messages';

// Canonical app-store destinations. Centralised so every store badge on
// the site (Hero, FloatingCTARail mobile panel, RegisterModal success
// step, UnderConstruction landing) points at the same URL — change it
// here once instead of hunting down four `href`s.

// Google Play listing for "I Love Cooking : Dream Farm".
// https://play.google.com/store/apps/details?id=io.gmillion.ilovecooking
//
// The `referrer` query param is Google Play's official install-attribution
// channel: its value is passed through to the app via the Play Install
// Referrer API on first launch. We encode a UTM-style payload so installs
// originating from this site are attributable as coming from the official
// website (decoded: `utm_source=official_website&utm_medium=web`). The
// inner `&`/`=` MUST stay percent-encoded (%26 / %3D) so they're read as
// part of the single `referrer` value rather than as separate Play Store
// query params.
const GOOGLE_PLAY_REFERRER =
  'utm_source%3Dofficial_website%26utm_medium%3Dweb';

// The `hl` query param sets the listing's display language; like the App
// Store's `l`, we track the site's current language (th/en) so the user
// lands on a store page in the language they were just reading. Returns a
// function (not a constant) because the value depends on the active
// language; call sites read `lang` from `useLanguage()`.
//   th → ...&hl=th&referrer=...
//   en → ...&hl=en&referrer=...
export function googlePlayUrl(lang: Lang): string {
  return `https://play.google.com/store/apps/details?id=io.gmillion.ilovecooking&hl=${lang}&referrer=${GOOGLE_PLAY_REFERRER}`;
}

// App Store listing for "I Love Cooking : Dream Farm" (id6762752920) on the
// Thai storefront (/th/). Unlike Google Play (where the `hl` display
// language is fixed), Apple's `l` query param sets the listing's display
// language — so we track the site's current language (th/en) and hand the
// user a store page in the language they were just reading.
//   th → https://apps.apple.com/th/app/id6762752920?l=th
//   en → https://apps.apple.com/th/app/id6762752920?l=en
// Returns a function (not a constant) because the value depends on the
// active language; call sites read `lang` from `useLanguage()`.
export function appStoreUrl(lang: Lang): string {
  return `https://apps.apple.com/th/app/id6762752920?l=${lang}`;
}
